<template>
  <div class="v-check-container">
    <svg class="animated-check" viewBox="0 0 24 24">
      <path d="M4.1 12.7L9 17.6 20.3 6.3" fill="none"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'v-check-animation'
}
</script>

<style lang="scss" scoped>

</style>
